var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoading
      ? _c("div", { staticClass: "wrap-title-component" }, [
          _vm._v("\n    " + _vm._s(_vm.titleComponent) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c("h5", { staticClass: "mb-2" }, [
          _vm._v("\n    " + _vm._s(_vm.titleView) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus fa-lg" }),
                    _vm._v(" Add\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                    _vm._v(" Import\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-download fa-lg" }),
                    _vm._v(" Export\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-filter fa-lg" }),
                    _vm._v(" Filter\n      ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("j-calender-view-widget", {
              attrs: {
                "form-data": _vm.formData,
                "form-ui": _vm.formUi,
                "use-title": false
              }
            })
          ],
          1
        )
      : _c("div", { staticClass: "skeleton-component" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e923e24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e923e24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyCalendarView.vue
// module id = null
// module chunks = 